export default __webpack_public_path__ + "static/media/0014.87d0dbf3.jpg";